import { FC } from 'react';
import { getCustomerFullName } from '@mews-commander/legacy-entities/src/ducks/customers';
import { useCommanderSelector } from '@mews-commander/utils';
import { Identified } from '@optimus-web/core';

const CustomerName: FC<Identified> = ({ id }) => {
    const customerName = useCommanderSelector((state) => getCustomerFullName(state, { id }));
    return <span data-test-id="customerName">{customerName}</span>;
};

export default CustomerName;
